import { render } from "./results-board.vue?vue&type=template&id=377a797c&scoped=true&ts=true"
import script from "./results-board.vue?vue&type=script&lang=ts"
export * from "./results-board.vue?vue&type=script&lang=ts"

import "./results-board.vue?vue&type=style&index=0&id=377a797c&lang=scss&scoped=true"
import "./results-board.vue?vue&type=style&index=1&id=377a797c&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-377a797c"]])

export default __exports__